import { render, staticRenderFns } from "./associatedOrderModel.vue?vue&type=template&id=3918d55a&scoped=true&"
import script from "./associatedOrderModel.vue?vue&type=script&lang=js&"
export * from "./associatedOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./associatedOrderModel.vue?vue&type=style&index=0&id=3918d55a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918d55a",
  null
  
)

export default component.exports